import { readWorkspaceLocalJson, writeWorkspaceLocalJson, WS_KEY } from "../../utils/workspaceStorage";

function isMap(value) {
  return value && typeof value === "object" && !Array.isArray(value);
}

function pickFilled(map) {
  const out = {};
  for (const [k, v] of Object.entries(isMap(map) ? map : {})) {
    const key = String(k || "").trim();
    const val = String(v || "").trim();
    if (key && val) out[key] = val;
  }
  return out;
}

function pickNames(list) {
  return [...new Set((Array.isArray(list) ? list : []).map((s) => String(s || "").trim()).filter(Boolean))];
}

export function emptyConcessionMaps() {
  return { dealerMap: {}, districtMap: {}, skippedDealers: [], skippedDistricts: [] };
}

export function loadConcessionMaps() {
  const raw = readWorkspaceLocalJson(WS_KEY.CONCESSION_IMPORT_MAP, null);
  if (!isMap(raw)) return emptyConcessionMaps();
  return {
    dealerMap: pickFilled(raw.dealerMap),
    districtMap: pickFilled(raw.districtMap),
    skippedDealers: pickNames(raw.skippedDealers),
    skippedDistricts: pickNames(raw.skippedDistricts),
  };
}

export function saveConcessionMaps({ dealerMap, districtMap, skippedDealers, skippedDistricts } = {}) {
  writeWorkspaceLocalJson(WS_KEY.CONCESSION_IMPORT_MAP, {
    dealerMap: pickFilled(dealerMap),
    districtMap: pickFilled(districtMap),
    skippedDealers: pickNames(skippedDealers),
    skippedDistricts: pickNames(skippedDistricts),
  });
}
